<template>
  <router-view />
</template>
<script>
import { useConfigStore } from "@/store/configStore";
export default {
  created() {
    const configStore = useConfigStore();
    document.title = configStore.title;
    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      sessionStorage.setItem("userInfo", userInfo);
    }
  },
};
</script>
<style lang="less">
html,
body,
#app {
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  router-view {
    min-height: 100vh;
  }
}

.el-popper {
  &.is-dark,
  &.is-light {
    max-width: 500px;
    white-space: pre-line;
  }
}

@media print {
  html,
  body,
  #app {
    font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
